import { Box, Center, Spacer } from "@chakra-ui/react";

import React from "react";

interface Iprops {
  Header?: React.ReactElement;
  Left?: React.ReactElement | JSX.Element;
  Right?: React.ReactElement;
  Footer?: React.ReactElement;
}

const AuthLayout = (props: Iprops) => {
  return (
    <Box
      mx={"auto"}
      h={"100vh"}
      p={{
        base: "screenPadding.base",
        sm: "screenPadding.sm",
        md: "sreenPadding.md",
      }}
    >
      <Box width={"100%"}>{props.Header}</Box>
      <Box
        display={"flex"}
        h={{ base: "none", lg: "90%" }}
        flexDirection={{ base: "column", lg: "row" }}
        alignItems={{ base: "inherit", lg: "center" }}
        justifyContent={{ base: "inherit", lg: "center" }}
        maxW={{ base: "100%", lg: "60rem" }}
        m={"auto"}
        gap={{ base: "2rem", md: "4rem", lg: "6rem" }}
      >
        <Box flex={1}>
          <Center>{props.Left}</Center>
        </Box>
        <Box
          w={"100%"}
          flex={{ base: "inherit", lg: 1 }}
          mt={{ base: "1rem", md: "1rem" }}
          mx="auto"
          maxW={{ base: "100%", md: "28rem" }}
        >
          {props.Right}
          <Spacer />
          {props.Footer}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
